/**
 * Warm the browser HTTP cache for DuckDB WASM and worker scripts while the user
 * is still on the landing page, so /kommun cold starts spend less time on network I/O.
 */
const DUCKDB_VERSION = '1.31.0';
const CDN_BASE = `https://cdn.jsdelivr.net/npm/@duckdb/duckdb-wasm@${DUCKDB_VERSION}/dist`;

let started = false;

export function warmDuckdbAssetsIdle(): void {
  if (typeof window === 'undefined' || started) return;
  started = true;

  const run = () => {
    const wasmUrls = [`${CDN_BASE}/duckdb-mvp.wasm`, `${CDN_BASE}/duckdb-eh.wasm`];
    for (const url of wasmUrls) {
      void fetch(url, { mode: 'cors', cache: 'default' }).catch(() => {});
    }
    const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
    for (const name of ['duckdb-browser-mvp.worker.js', 'duckdb-browser-eh.worker.js']) {
      void fetch(`${base}/workers/${name}`, { cache: 'default' }).catch(() => {});
    }
  };

  // Avoid `'requestIdleCallback' in window` — with current DOM typings the else branch becomes unreachable
  // and `window` is narrowed to `never`, breaking `window.setTimeout`.
  const w = window as Window & { requestIdleCallback?: (cb: () => void, opts?: IdleRequestOptions) => number };
  if (typeof w.requestIdleCallback === 'function') {
    w.requestIdleCallback(() => run(), { timeout: 4000 });
  } else {
    setTimeout(run, 2500);
  }
}
